<template>
  <div class="leave page-main-box">
    <headers :type="2"></headers>
    <div class="leave-container">
        <div class="tips-pic">
            
        </div>
        <h2>您当前为离职状态，加入一家新公司前将无法进行任何操作</h2>
        <dl>
            <dt>您可以使用当前手机号<span v-if="mobile">（{{mobile}}）</span></dt>
            <dd><span></span>重新注册一家新公司，注册成功后您将成为新公司的管理员</dd>
            <dd><span></span>接受其他公司的注册邀请，接受邀请后您成为该公司的员工</dd>
            <dd><Button  type="primary"  @click="logout">退出</Button></dd>
        </dl>
    </div>
  </div>
</template>

<script>

import headers from '@/components/header';
import DB from '@/common/db'

export default {
  name: 'leave',
  data () {
      return {
          mobile:null
      }
  },
  methods:{
      logout(){
        DB.request({
            url: DB.prefix + 'auth/v2/logout',
            success(){
                window.location.href = '/'
            }
        });
      }
  },
  components:{
    headers
  },
  created(){
    DB.request({
        url: DB.prefix + 'auth/v2/link',
        type:'get',
        success:(data)=>{
          if(data.data.isLogin){
            DB.request({
                url: DB.prefix + 'auth/v2/getUserData',
                
                success:(res)=>{
                  
                  this.mobile = res.data.userDetail.profile.mobilePhone;
                },
                complete(){
                  
                }
            });
          }else{//未登录
            //window.location.href = `/index.html#/?url=${encodeURIComponent(location.href)}`;
            window.location.href = `/index.html`;
          }
        }
    });
    
  },
  mounted(){
  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
  .leave {}
  .leave-container {
      margin:0 auto;
      margin-top:50px;
      width:500px;
      
      .tips-pic {
          width:166px;
          height:220px;
          background:url('tip.png') no-repeat left top;
          margin:0 auto;
      }
      h2 {
          font-size:18px;
          margin-top:30px;
      }
      dl {
          margin-top:10px;
          font-size:14px;
          line-height:30px;
          dt {
              
          }
          dd {
              text-indent:20px;
              span {
                    height: 4px;
                    width: 4px;
                    background: #3C89F3;
                    display: inline-block;
                    margin-right: 4px;
                    margin-top: -1px;
                    position: relative;
                    top: -3px;
              }
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/leavePerson/leave.vue